module.exports = __webpack_public_path__ + "static/media/ECMediaLogo.20ca0dae.svg";